import React from "react";
import Row from "react-bootstrap/Row";
import Dropdown from "react-bootstrap/Dropdown";
import { filterDocumentsByCategory } from "../components/utilities";
import { Heading, DownloadMenu, NoDataFound } from "../components/helpful";
import {NotificationSkeleton} from '../components/skeleton'


/* The `Notification` class in JavaScript handles notifications, displays unread documents, and updates
the view status of items. 
@author lionel ghogue ngondeke <lionelladrog@gmail.com>
*/
export default class Notification extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      pageTitle: "Notifications",
      nb_notifs: 0,
      isExisting: false,
      isLoading: false,
      factsheets: [],
      has_view_classes: {} 
    };

    this.confirmView = this.confirmView.bind(this);
    this.waitForValue = this.waitForValue.bind(this);
  }

  async componentDidMount() {
    if (this.props.files && this.props.files.length > 0) {
      this.setState({ isLoading: true });
      const newdocuments = await filterDocumentsByCategory(this.props.id);


      if (newdocuments.length > 0) {
        this.setState({
          factsheets: newdocuments,
          nb_notifs: this.props.unread_nb,
          isLoading: false
        });

     
        newdocuments.forEach((list) => {
          list.content.forEach(async (item) => {
            const className = await this.confirmView(item.has_view);
            this.setState((prevState) => ({
              has_view_classes: {
                ...prevState.has_view_classes,
                [item.id]: className
              }
            }));
          });
        });
      }
    }
  }

  async componentDidUpdate(prevProps) {
    if (prevProps.id !== this.props.id) {
      if (this.props.files && this.props.files.length > 0) {
        this.setState({ isLoading: true });
        const newdocuments = await filterDocumentsByCategory(this.props.id);

        let count = 0;
        if (newdocuments.length > 0) {
          newdocuments.forEach((item) => {
            count += item.content.length;
          });

          this.setState({
            factsheets: newdocuments,
            nb_notifs: this.props.unread_nb,
            isLoading: false
          });

          
          newdocuments.forEach((list) => {
            list.content.forEach(async (item) => {
              const className = await this.confirmView(item.has_view);
              this.setState((prevState) => ({
                has_view_classes: {
                  ...prevState.has_view_classes,
                  [item.id]: className
                }
              }));
            });
          });
        }
      }
    }
  }

  subHeading = () => {
    
    return <>{`( ${this.state.nb_notifs.toString()} unread Document(s) )`}</>;
  };

  waitForValue(has_view) {
    return new Promise((resolve) => {
      if (has_view !== null) {
        setTimeout(() => {
          resolve("has_view");
        }, 1000);
      } else {
        resolve(null);
      }
    });
  }

  confirmView = async (has_view) => {
    let val = await this.waitForValue(has_view);
    return val ? "has_view" : "";
  };

  render() {
    return (
      <div>
        <div className="">
          <div className="sticky-top">
            <Heading heading={this.state.pageTitle} Desc={this.subHeading} />
          </div>
          <Row className="main-content">
            {this.state.isLoading ? (<div>
              {/* <h6 className="px-4">No documents available at the moment.</h6> */}
              <NotificationSkeleton />
              </div>
              
            ) : this.state.factsheets && this.state.factsheets.length > 0 ? (
              this.state.factsheets.map((list, index) => {
                return (
                  <div key={index}>
                    <h5 className="unordered-list-title">{list.category}:</h5>
                    <ul className="unordered-list">
                      {list.content.map((item) => {
                        return (
                          <li
                            key={item.id+Math.random()} 
                            className={`${'' || this.state.has_view_classes[item.id]}`}
                          >
                            <span>{item.title}</span>
                            <DownloadMenu item={item} />

                            <p
                              className={`${'' || this.state.has_view_classes[item.id]}`}
                            >
                              {item.date}
                            </p>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                );
              })
            ) : (
              <NoDataFound />
            )}
          </Row>
        </div>
      </div>
    );
  }
}
